import { createContext, useContext, useEffect, useState } from "react";
import { getRemainingTime } from "../utils/countdownTimer";

const CountdownContext = createContext({
  countdown: 0,
  handleCountdown: (seconds) => {},
  hasTimeExpired: false,
  isCountdownActive: true,
});

export function CountdownProvider({ children }) {
  const [countdown, setCountdown] = useState(0);
  const [hasTimeExpired, setHasTimeExpired] = useState(false);

  const [remainingTime, setRemainingTime] = useState({
    seconds: "00",
    minutes: "00",
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(getRemainingTime(countdown));
    }, 1000);

    return () => clearInterval(interval);
  }, [countdown]);

  useEffect(() => {
    if (
      !!Object.keys(remainingTime).length &&
      remainingTime.seconds === "00" &&
      remainingTime.minutes === "00"
    ) {
      setHasTimeExpired(true);
      return;
    }

    setHasTimeExpired(false);
  }, [remainingTime]);

  const handleCountdown = (seconds) => {
    const milisecondsCountdownUntilNow = seconds * 1000 + new Date().getTime();
    setCountdown(milisecondsCountdownUntilNow);
  };

  return (
    <CountdownContext.Provider
      value={{
        countdown,
        handleCountdown,
        hasTimeExpired,
        remainingTime,
      }}
    >
      {children}
    </CountdownContext.Provider>
  );
}

export function useCountdown() {
  const context = useContext(CountdownContext);

  return context;
}
